export * from './lib/tile-gallery.module';

export * from './lib/components/tile/tile.component.module';
